/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import {
  httpClient,
} from '@/middlewares/httpClient';
import { FLOW_MANAGER } from '../flow/apis';
import { TypeLibrary } from './models';

const GetTypes = (id: string) => httpClient
  .get(`${FLOW_MANAGER}/workspaces/${id}/types`);

const AddType = (workspaceId: string, newType: TypeLibrary) => httpClient
  .post(`${FLOW_MANAGER}/workspaces/${workspaceId}/types`, newType);

const DeleteType = (workspaceId: string, typeId: string) => httpClient
  .delete(`${FLOW_MANAGER}/workspaces/${workspaceId}/types/${typeId}`);

const UpdateType = (workspaceId: string, type: TypeLibrary) => httpClient
  .put(`${FLOW_MANAGER}/workspaces/${workspaceId}/types/${type.id}`, type);

const ResolvedTypes = (id: string) => httpClient
  .get(`${FLOW_MANAGER}/workspaces/${id}/types_resolved`);

const ResolvedType = (id: string, typeId: string) => httpClient
  .get(`${FLOW_MANAGER}/workspaces/${id}/types/${typeId}/resolved`);

export {
  GetTypes, AddType, DeleteType, UpdateType, ResolvedTypes, ResolvedType,
};
